module.exports = __webpack_public_path__ + "static/media/bos1.1d339ab8.svg";